import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatINR } from "../lib/api";
import { ArrowUpRight } from "lucide-react";

export default function Programs() {
  const [programs, setPrograms] = useState([]);

  useEffect(() => {
    api.get("/programs").then((r) => setPrograms(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="programs-page" className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28">
      <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-novya-muted mb-8">
        All programs · September 2026 intake
      </div>
      <h1 className="font-display font-black text-5xl md:text-7xl lg:text-8xl tracking-tighter leading-[0.9] text-novya-ink max-w-4xl">
        Four tracks. Built for shipping.
      </h1>
      <p className="mt-8 text-base md:text-lg text-novya-muted max-w-2xl leading-relaxed">
        Each program runs live for one full cohort — mentored end-to-end by practitioners currently shipping in their field.
      </p>

      <div className="mt-20 border-t border-novya-border">
        {programs.map((p, i) => (
          <Link
            to={`/programs/${p.slug}`}
            data-testid={`programs-row-${p.slug}`}
            key={p.slug}
            className="group grid grid-cols-1 md:grid-cols-12 gap-6 py-10 md:py-14 border-b border-novya-border hover:bg-novya-ink hover:text-white transition-colors duration-300 px-4 -mx-4"
          >
            <div className="md:col-span-1 font-mono text-xs tracking-widest text-novya-muted group-hover:text-white/40 pt-3">
              0{i + 1}
            </div>
            <div className="md:col-span-5">
              <h2 className="font-display font-black text-3xl md:text-5xl tracking-tighter leading-tight">
                {p.title}
              </h2>
            </div>
            <div className="md:col-span-4 text-novya-muted group-hover:text-white/70 leading-relaxed">
              {p.tagline}
            </div>
            <div className="md:col-span-2 flex md:flex-col items-start justify-between gap-2">
              <div className="font-mono text-xs tracking-wide">{p.duration}</div>
              <div className="font-mono text-xs tracking-wide text-novya-muted group-hover:text-white/50">{formatINR(p.price_inr)}</div>
              <ArrowUpRight size={22} className="group-hover:rotate-45 transition-transform" />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
